@let size = size$ | async;
@let showLabels = size ? size.more(labelsFrom) : false;

<nav class="nav-tabs" [attr.aria-label]="'term.main-navigation' | translate">
  @for (item of items; track item.value) {
    <button type="button"
      class="nav-item"
      [class.active]="item.value === activeValue"
      [class.icon-only]="!showLabels"
      [attr.aria-current]="item.value === activeValue ? 'page' : null"
      [attr.aria-label]="item.text | translate"
      (click)="select.emit(item)">
      <mat-icon
        [matBadge]="item.badge"
        [matBadgeHidden]="!item.badge"
        [matBadgeOverlap]="true"
        [matBadgeSize]="'small'">
        {{ item.icon }}
      </mat-icon>
      @if (showLabels) {
        <span class="nav-label" [class.reduce-text]="item.reduceLabel">
          {{ (item.text | translate) | titlecase }}
        </span>
      }
    </button>
  }
</nav>

<mat-menu #menu="matMenu" class="mobile-menu">
  @for (item of items; track item.value) {
    <button mat-menu-item class="app-menu-item primary" (click)="select.emit(item)">
      <mat-icon [matBadge]="item.badge"
        [matBadgeHidden]="!item.badge"
        [matBadgeOverlap]="true"
        [matBadgeColor]="'accent'"
        [matBadgeSize]="'small'">
        {{ item.icon }}
      </mat-icon>
      {{ (item.text | translate) | titlecase }}
    </button>
  }
</mat-menu>

@let active = activeItem;

@if (active) {
  <button mat-button [matMenuTriggerFor]="menu" class="mobile-menu app-button stroked white-primary">
    <mat-icon [matBadge]="active.badge"
      [matBadgeHidden]="!active.badge"
      [matBadgeOverlap]="true"
      [matBadgeColor]="'accent'"
      [matBadgeSize]="'small'">{{ active.icon }}
    </mat-icon>
    {{ (active.text | translate) | titlecase }}
  </button>
}
